<template>
  <div>
    <h2>{{pageTitle}}</h2>
  </div>
</template>

<!-- 信息流-分类管理 -->
<script>
export default {
  components: {},
  data () {
    return {
      pageTitle: '分类管理'
    }
  },
  methods: {}
}
</script>

<style scoped>
  h2 {
    font-size: 20px;
  }
</style>
